export default {
  placeholder: 'Search address',
  edit: 'Edit address',
  manualEntry: 'Enter the address manually',
  cancelButton: 'Cancel',
};
